import React from 'react';
import { useTranslation } from 'react-i18next';
import "./navbar.css"


const Navbar = () => {

    const { i18n } = useTranslation();

    const changeLanguage = (lang, event) => {
        event.preventDefault();
        i18n.changeLanguage(lang);
    };

    return (
        <nav>
            <div className="navigation">
                <a href="https://cruisemybay.pl/">
                    <img className="logo" src={`${process.env.PUBLIC_URL}/cruise-my-bay-white-font-on-transparent-background.png`}/>
                </a>
                <div className="language-buttons">
                    <button className="lang-btn" type="button" onClick={(e) => {changeLanguage('en', e); e.currentTarget.blur();}}>
                        <img src={`${process.env.PUBLIC_URL}/flags/gb.png`} alt="English" className="flag-icon" />
                        EN
                    </button>
                    <button className="lang-btn" type="button" onClick={(e) => {changeLanguage('pl', e); e.currentTarget.blur();}}>
                        <img src={`${process.env.PUBLIC_URL}/flags/pl.png`} alt="Polski" className="flag-icon" />
                        PL
                    </button>
                </div>
            </div>
            
        </nav>
    )
}

export default Navbar